import { c as _c } from "react/compiler-runtime";
import type { FC, HTMLProps } from "react";
import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import clsx from "clsx";
import { Icon, Tooltip } from "../../widgets";
import { Input } from "../Input";
import type { PasswordInputProps } from "./PasswordInput.d";
import styles from "./PasswordInput.module.scss";
export const PasswordInput: FC<Omit<HTMLProps<HTMLInputElement>, keyof PasswordInputProps> & PasswordInputProps> = t0 => {
  const $ = _c(23);
  let T0;
  let onToggle;
  let show;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      onToggle: t4,
      show: t5,
      ...props
    } = t0;
    onToggle = t4;
    show = t5;
    t3 = styles.container;
    T0 = Input;
    t1 = props;
    t2 = clsx(props.className, "ph-no-capture");
    $[0] = t0;
    $[1] = T0;
    $[2] = onToggle;
    $[3] = show;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    T0 = $[1];
    onToggle = $[2];
    show = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2) {
    t4 = <T0 {...t1} className={t2} />;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = show ? "Hide" : "Show";
  const t6 = show ? faEye : faEyeSlash;
  let t7;
  if ($[11] !== t6) {
    t7 = <Icon icon={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onToggle || $[14] !== t7) {
    t8 = <button className={styles.toggle} onClick={onToggle} type="button">{t7}</button>;
    $[13] = onToggle;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <Tooltip placement="right" text={t5}>{t8}</Tooltip>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t9) {
    t10 = <div className={t3}>{t4}{t9}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default PasswordInput;